import React, { useEffect, useState } from 'react'
import Topbar from '../components/Layout/Topbar'
import { useSelector } from 'react-redux'
import { supabase } from '../supabase.config'
import PickupListing from '../components/CreateDeliveryOrder.js/PickupListing'
import { Sidebar } from '../components/Layout/Sidebar'

const PickupBoyList = () => {
    const [pickupList, setPickupList] = useState([])
    const { error, loading, isAuthenticated,users,userProfile } = useSelector(
        (state) => state.user
      );
    const fetchPickupList = async () =>{
      try {
        const { data: { user } } = await supabase.auth.getUser()
        if (!user) return
        const { data, error } = await supabase
          .from('request_pickups')
          .select('*')
          .eq('assigned_delivery_boy_id', user.id)
          .eq('pickup_status', 'pickingUp')
          .order('created_at', { ascending: false })
        if (error) throw error
        const mapped = (data || []).map(row => ({ id: row.id, location: row.location || {}, pickupStatus: row.pickup_status }))
        setPickupList(mapped)
      } catch (e) {
        console.error('Failed to fetch pickup list', e)
        setPickupList([])
      }
    }
      console.log(pickupList)
      useEffect(() => {
        fetchPickupList()
      }, [])
      
  return (
    <div className='crm-app-shell flex min-h-screen gap-3 p-3'>
        <Sidebar />
        <div className='crm-page-scroll flex min-w-0 flex-1 flex-col'>
          <Topbar />
          <PickupListing fetchPickupList={fetchPickupList} pickupList={pickupList} />
        </div>
    </div>
  )
}

export default PickupBoyList
